import { Box, MenuItem, Select, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import OutlinedInput from "@mui/material/OutlinedInput";
import Typography from "@mui/material/Typography";

import useInputObject from "../../../hooks/useInputObject";
import { getHyphenedDate } from "../../../utils/utils";

const SearchHistory = (props) => {
  const { reportTypes, SearchReport } = props;
  const searchForm = useInputObject({
    reportTypeId: 1,
    keyValue: null,
    targetDateFrom: getHyphenedDate(new Date()),
    targetDateTo: getHyphenedDate(new Date()),
  });
  return (
    <Box border="1px solid blue" borderRadius={1} padding={2}>
      <Grid item>
        <Typography>履歴検索</Typography>
      </Grid>
      <Box margin={2} marginBottom={1}>
        <Grid container alignItems="center" marginBottom={1} spacing={6}>
          <Grid item xs={7}>
            <Box display="flex" flexDirection="row">
              <Stack
                display="flex"
                flexDirection="row"
                height={50}
                alignItems="center"
                marginRight={5}
              >
                <Typography>帳票タイプ :&nbsp;</Typography>
                <Select
                  value={searchForm.Value.reportTypeId}
                  onChange={(e) =>
                    searchForm.update("reportTypeId", e.target.value)
                  }
                  sx={{ minWidth: 400, fontSize: 20 }}
                >
                  {reportTypes.map((invoice, i) => {
                    return (
                      <MenuItem
                        key={`reportType${i}`}
                        value={invoice.reportTypeId}
                      >
                        {invoice.reportTypeName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </Stack>
              <Stack
                display="flex"
                flexDirection="row"
                height={50}
                alignItems="center"
              >
                <Typography>検索キーワード :&nbsp;</Typography>
                <OutlinedInput
                  sx={{ width: 300, fontSize: 20 }}
                  onChange={(e) =>
                    searchForm.update("keyValue", e.target.value)
                  }
                  value={searchForm.Value.keyValue}
                />
              </Stack>
            </Box>
          </Grid>
          <Grid item xs={5}>
            <Stack
              display="flex"
              flexDirection="row"
              height={50}
              alignItems="center"
              marginRight={5}
            >
              <Typography>対象日 :&nbsp;</Typography>
              <OutlinedInput
                type="date"
                sx={{ width: 200, fontSize: 20 }}
                inputProps={{
                  min: "1000-01-01",
                  max: "9999-12-31",
                }}
                onChange={(e) =>
                  searchForm.update("targetDateFrom", e.target.value)
                }
                value={searchForm.Value.targetDateFrom}
              />
              &nbsp;から&nbsp;
              <OutlinedInput
                type="date"
                sx={{ width: 200, fontSize: 20 }}
                inputProps={{
                  min: "1000-01-01",
                  max: "9999-12-31",
                }}
                onChange={(e) =>
                  searchForm.update("targetDateTo", e.target.value)
                }
                value={searchForm.Value.targetDateTo}
              />
              &nbsp;まで
            </Stack>
          </Grid>
        </Grid>

        <Grid
          container
          alignItems="center"
          justifyContent="flex-end"
          spacing={1}
        >
          <Grid item xs="auto">
            <Button
              variant="contained"
              onClick={() => SearchReport(searchForm.Value)}
            >
              検索
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
export default SearchHistory;
